import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import ListLayout from "../../../../../partials/content/ListLayout";
import { getRecIncomingInvoiceDetail } from "../../../../../services/finance/incomingInvoice";
import Notes from "../../../common/notes";
import RecIncomingInvoiceBasicInfo from "./recIncomingInvoiceBasicInfo";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function RecIncomingInvoiceDetail({ match, history }) {
  const { reload } = useGlobalData();
  const invoiceID = match.params.invoiceID;
  const [invoice, setInvoice] = useState({
    ID: 0,
    vendor: {
      vendorName: "",
    },
  });
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [listMenu, setListMenu] = useState([
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
  ]);

  const defaultSelected = "basicInfo";

  useEffect(() => {
    getIncomingInvoiceData(invoiceID);
  }, [invoiceID, reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/invoices/AP",
            title: "Invoices",
            active: false,
          },
          {
            page: "/finance/incoming-invoice-detail/" + invoiceID,
            title: "Recurring Account Payable ID " + invoiceID,
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/finance/invoices/AP");
            },
          },
        ]}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            let selectedComponent;
            switch (key) {
              case "basicInfo":
                selectedComponent = (
                  <RecIncomingInvoiceBasicInfo invoice={invoice} />
                );
                setHeaderTitle("Basic Info");
                break;
              case "notes":
                selectedComponent = <Notes docType="RNVR" docID={invoice.ID} />;
                setHeaderTitle("Notes");
                break;
              default:
                selectedComponent = (
                  <RecIncomingInvoiceBasicInfo invoice={invoice} />
                );
                setHeaderTitle("Basic Info");
                break;
            }
            setComponent(selectedComponent);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
    </React.Fragment>
  );

  async function getIncomingInvoiceData(invoiceID) {
    const response = await getRecIncomingInvoiceDetail(invoiceID);
    const { data } = response.data;
    const componentTmp = (
      <RecIncomingInvoiceBasicInfo invoice={data.recIncomingInvoice} />
    );
    setInvoice(data.recIncomingInvoice);
    setComponent(componentTmp);
  }
}

export default RecIncomingInvoiceDetail;
